document.addEventListener("DOMContentLoaded", () => {

    document.querySelectorAll(".brms-slider").forEach(slider => {

        const totalSlides =
            slider.querySelectorAll(".swiper-slide").length;


        /* ==========================================================
           SWIPER
        ========================================================== */

        const swiper = new Swiper(slider, {

            slidesPerView: 1,

            speed: 650,

            effect: "fade",

            fadeEffect: {
                crossFade: true
            },

            grabCursor: true,

            loop: totalSlides > 1

        });


        /* ==========================================================
           GUARDAR SWIPER EN EL SLIDER
        ========================================================== */

        slider.brmsSwiper = swiper;


        /* ==========================================================
           FLECHA SIGUIENTE
        ========================================================== */

        const nextButtons =
            slider.querySelectorAll(".brms-next");

        nextButtons.forEach(button => {

            button.addEventListener("click", function(e) {

                e.preventDefault();

                e.stopPropagation();

                e.stopImmediatePropagation();

                swiper.slideNext();

            }, true);

        });


        /* ==========================================================
           FLECHA ANTERIOR
        ========================================================== */

        const prevButtons =
            slider.querySelectorAll(".brms-prev");

        prevButtons.forEach(button => {

            button.addEventListener("click", function(e) {

                e.preventDefault();

                e.stopPropagation();

                e.stopImmediatePropagation();

                swiper.slidePrev();

            }, true);

        });

    });


    /* ==========================================================
       AGREGAR COMPONENTE AL CARRITO
    ========================================================== */

    document.addEventListener("click", async e => {

        const btn = e.target.closest(".brms-add");

        if(!btn) return;

        e.preventDefault();

        btn.disabled = true;

        try{

            const id = btn.dataset.variant;

            const res = await fetch("/cart/add.js", {

                method:"POST",

                headers:{
                    "Content-Type":"application/json"
                },

                body:JSON.stringify({

                    id:id,

                    quantity:1

                })

            });

            if(!res.ok) throw new Error();

            btn.classList.add("is-added");

            btn.textContent = "Agregado";

            document.dispatchEvent(
                new CustomEvent("cart:refresh")
            );

        }catch(err){

            console.error(err);

            alert("No fue posible agregar el producto.");

        }

        setTimeout(() => {

            btn.disabled = false;

            btn.classList.remove("is-added");

            btn.textContent = "Agregar";

        },1800);

    });

});